import React, { Component } from 'react';
import * as analytics from '../lib/analytics';

import { BodyText, HeadingText, Modal, Button } from '@paypalcorp/pp-react';

import glamorous from 'glamorous';
import styles from './stripe.less';

const StripeDiv = glamorous.div({
  padding: '24px 0px',
  '@media(max-width: 575px)': {
    padding: '24px 25px',
  },
});

const MessageContainer = glamorous.div({
  textAlign: 'center',
});

const TermLink = glamorous(BodyText)({
  padding: '5px',
  margin: '0px auto',
  textAlign: 'center',
});

const TermTitle = glamorous(HeadingText)({
  textAlign: 'center',
  margin: '0 auto',
});

const Terms = glamorous.div({
  padding: '30px',
});

const TermOl = glamorous(BodyText)({
  listStyleType: 'decimal',
});

const TermImage = glamorous.div({
  textAlign: 'center',
  marginBottom: '23px',
});

export default class Stripe extends Component {
  constructor(props) {
    super(props);

    this.handleAnalytics = this.handleAnalytics.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.renderLink = this.renderLink.bind(this);
    this.renderModal = this.renderModal.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.state = {
      showModal: false,
    };
  }

  handleAnalytics(link) {
    analytics.trackLink(
      link,
      this.props.fptiInfo.pgrp,
      this.props.fptiInfo.page,
      'link'
    );
  }

  handleClick(event) {
    this.setState({ showModal: true });
    this.handleAnalytics('PPGFDonatingDetails');
  }

  handleKeyPressOnLink(e) {
    if (e.key === 'Enter') {
      this.handleClick();
    }
  }

  handleClose(event) {
    this.setState({ showModal: false });
    this.handleAnalytics('PPGFDonatingDetails');
  }

  renderLink() {
    const href = this.props.i18n('label.learn-more-link');
    const content = this.props.i18n('label.learn-more');
    if (!!href && href !== '/') {
      // normal link to 'learn more content'
      return (
        <button
          href={href}
          onClick={this.handleClick}
          tabIndex='0'
          role='link'
          className={styles.modalLink}
        >
          {content}
        </button>
      );
    } else if (href) {
      // open a modal to display 'learn more content'
      return (
        <button
          data-ppvx_modal-id='stripeTerms'
          onKeyDown={this.handleKeyPressOnLink.bind(this)}
          onClick={this.handleClick}
          className={styles.modalLink}
        >
          {content}
        </button>
      );
    }
  }

  renderModal() {
    const title = this.props.i18n('label.terms-title');
    const termsLink = this.props.i18n('label.terms-link');
    let terms = this.props.i18n('label.terms');
    if (!Array.isArray(terms)) {
      terms = [];
    }
    const ModalBody = (
      <div>
        <TermImage>
          <img
            alt=''
            src={`https://${this.props.cdnHost}/images/Cause/hub/ic_blueheart.svg`}
          />
        </TermImage>
        <TermTitle as='p' id={title} size='sm' regular>
          {title}
        </TermTitle>
        <Terms>
          <TermOl as='ol'>
            {terms.map((term, i) => (
              <li key={i}>
                <BodyText
                  size='md'
                  dangerouslySetInnerHTML={{ __html: term }}
                />
              </li>
            ))}
            <li key='term'>
              <BodyText
                size='md'
                dangerouslySetInnerHTML={{ __html: termsLink }}
              />
            </li>
          </TermOl>
        </Terms>
      </div>
    );
    return (
      <Modal
        isOpen={this.state.showModal}
        onClose={this.handleClose}
        footerContents={
          <Button
            className={styles.modalButton}
            onClick={this.handleClose}
            secondary
          >
            Ok
          </Button>
        }
        footerAlign='center'
      >
        {ModalBody}
      </Modal>
    );
  }

  render() {
    let message = this.props.message;
    if (!message) {
      message = this.props.i18n('label.stripe-message');
    }

    return (
      <StripeDiv>
        {this.renderModal()}
        <MessageContainer>
          <HeadingText
            as='p'
            size='md'
            className={styles.stripeTerms}
            dangerouslySetInnerHTML={{ __html: message }}
          ></HeadingText>
          {this.props.isPPGF && <TermLink>{this.renderLink()}</TermLink>}
        </MessageContainer>
      </StripeDiv>
    );
  }
}
